import mrqIgnored from './src/mrq-ignored';

export const ignoreActionMiddleware = (ignoredActions = mrqIgnored) => (store) => (next) => (
  action
) => (ignoredActions.includes(action.type) ? undefined : next(action));
